<angular2-multiselect
    [data]="values"
    [(ngModel)]="selectedValue" 
    [settings]="dropdownSettings"
    (onSelect)="onFilterValueDeSelect(selectedValue)" 
    (onDeSelect)="onFilterValueDeSelect(selectedValue)"
    (onDeSelectAll)="onFilterValueDeSelect($event)" 
    [title]="title">
</angular2-multiselect>
